import React, { useEffect, useState } from 'react'
import MainLayout from '../../containers/MainLayout'
import Image from '../../baseComponents/Image'
import CheckBox from './components/CheckBox'
import { connect } from 'react-redux'
import { searchService } from '../../services/search'

import { langTexts } from './locals'

import { ReactComponent as Logo } from '../../assets/images/title-icons/Compass-Line.svg'
import { ReactComponent as EnterArrow } from '../../assets/images/svg_icons/enter_arrow.svg'
import logo from '../../assets/images/title-icons/Compass-Line.svg'
import searchIcon from '../../assets/images/svg_icons/Search.svg'

import './index.css'
import { Link } from 'react-router-dom'

const Search = props => {
  const { lang } = props.settings
    , texts = langTexts[lang]

  const [activeClass, setActiveClass] = useState('')
    , [pagesVisible, setPagesVisible] = useState(true)
    , [productsVisible, setProductsVisible] = useState(true)
    , [amountFilter, /* setAmountFilter */] = useState(-1)
    , [tagsVisible, setTagsVisible] = useState(true)
    , { searchText = '', onSearchTextChange = () => null } = props
    , [result, setResult] = useState(null)

  const onSearch = () => {
    searchService(searchText)
      .then(res => {
        setResult(res)
      })
      .catch(err => console.log('err', err))
  }

  useEffect(() => {
    onSearch()
    setTimeout(() => {
      setActiveClass('active')

    }, 500)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  if (!result) {
    return null
  }


  let items = result[lang]
    , pages = items.page ? items.page : []
    , posts = items.product ? items.posts : []
    , products = items.product ? items.product : []

  if (!pagesVisible) pages = []
  if (!productsVisible) products = []
  if (!tagsVisible) posts = []

  let amountItems = pages.length + posts.length


  if (Number(amountFilter) !== -1 && amountItems > amountFilter) {
    let halfItems = Math.floor(amountFilter / 2)
      , productHalf = posts.length - halfItems
    //, pagesHalf = pages.length - halfItems

    if (productHalf < 0) halfItems -= productHalf

    pages = pages.filter((_, i) => i < halfItems)
    halfItems = Math.floor(amountFilter - pages.length)
    posts = posts.filter((_, i) => i < halfItems)

    amountItems = pages.length + posts.length
  }


  return <MainLayout id='search' className={`${activeClass}`} logo={<Logo />}>
    <div className='search__bar'>
      <div className='gray-line' />
      <div className='search__bar-content'>
        <img src={logo} className='title-logo transition' alt='page icon' />
        <div className='header__search transition'>
          <input placeholder='Buscar'
            value={searchText}
            onChange={e => onSearchTextChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') onSearch()
            }}
          />
          <img src={searchIcon} alt='search' onClick={onSearch} />
        </div>
      </div>
    </div>

    <div className='search__block search__results'>
      <div className='search__block-padding'>
        <div className='gray-line' />
        <img src={logo} className='title-logo transition' alt='page icon' />
      </div>
      <div>
        <span>{texts.searchTitle1}</span>
        <span className='red-color'> {amountItems} </span>
        <span>{texts.searchTitle2}</span>
      </div>
    </div>

    <div className='search__block search__results'>
      <div className='search__block-padding'>
        <div className='gray-line' />
        <img src={logo} className='title-logo transition' alt='page icon' />
      </div>
      <div className='search__filters-tag'>
        <div className='search__filter-tags'>
          <span>{texts.filtersLabel}: </span>
          <div className='search__checkbox'>
            <CheckBox label={texts.pagesLabel} isChecked={pagesVisible} onChange={() => setPagesVisible(!pagesVisible)} />
            <CheckBox label={texts.productsLabel} isChecked={productsVisible} onChange={() => setProductsVisible(!productsVisible)} />
            <CheckBox label={texts.tagsLabel} isChecked={tagsVisible} onChange={() => setTagsVisible(!tagsVisible)} />
          </div>
        </div>
        <div className='search__filter-sort'>
          {/* <div className='search__filter-item'>
            <span>{texts.amountLabel}</span>
            <select value={amountFilter} onChange={e => setAmountFilter(e.target.value)} placeholder='Cantidad'>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={30}>30</option>
              <option value={-1}>Todos</option>
            </select>
          </div> */}
        </div>
      </div>
    </div>



    <div className='search__block search__block-title'>
      <div className='search__block-padding'>
        <div className='gray-line' />
        <img src={logo} className='title-logo transition' alt='page icon' />
      </div>
      <div className='search__section-title'>
        <span className='red-color border-bottom'>{texts.pagesResult}</span>
      </div>
    </div>

    <div className='search__block search__block-title'>
      <div className='search__block-padding'>
        <div className='gray-line' />
        <img src={logo} className='title-logo transition' alt='page icon' />
      </div>
      <div className='search__page-item'>
        {
          pages.map((page, index) => <div key={index} className='search__page-item'>
            <h3>{page.titulo}</h3>
            <div dangerouslySetInnerHTML={{ __html: page.contenido }} />
            <Link className='search__section-btn' to={`/${page.slug}`}>
              <span><EnterArrow /></span>
            </Link>
          </div>)
        }
      </div>
    </div>

    <div className='search__block search__block-title'>
      <div className='search__block-padding'>
        <div className='gray-line' />
        <img src={logo} className='title-logo transition' alt='page icon' />
      </div>
      <div className='search__section-title'>
        <span className='red-color border-bottom'>{texts.tagsResult}</span>
      </div>
    </div>

    <div className='search__block search__block-title'>
      <div className='search__block-padding'>
        <div className='gray-line' />
        <img src={logo} className='title-logo transition' alt='page icon' />
      </div>
      <div className='search__page-item'>
        {
          posts && posts.map((page, index) => <div key={index} className='search__page-item'>
            <h3>{page.title}</h3>
            <div dangerouslySetInnerHTML={{ __html: page.contenido }} />
            <Link className='search__section-btn' to={`/blog/${page.slug}`}>
              <span><EnterArrow /></span>
            </Link>
          </div>)
        }
      </div>
    </div>

    <div className='search__block search__block-title'>
      <div className='search__block-padding'>
        <div className='gray-line' />
        <img src={logo} className='title-logo transition' alt='page icon' />
      </div>
      <div className='search__section-title'>
        <span className='red-color border-bottom'>{texts.productsResult}</span>
      </div>
    </div>

    <div className='search__block search__block-title'>
      <div className='search__block-padding'>
        <div className='gray-line' />
        <img src={logo} className='title-logo transition' alt='page icon' />
      </div>
      <div className='search__page-item'>
        {
          products.map((product, index) => <div key={index} className='search__page-item'>
            <div className='products__modal-container'>
              <Image className='products__product-image' src={`${product.img}`} />
              <div>
                <h2>{product.nmDroga}</h2>
                <p>
                  <b>{texts.nmDroga}</b>: {product.nmDroga}
                </p>
                <p>
                  <b>{texts.prncpioActvReg}</b>: {product.prncpioActvReg}
                </p>
              </div>
            </div>
          </div>)
        }
      </div>
    </div>

  </MainLayout>
}

const mapStateToProps = state => ({
  settings: state.settings
})

export default connect(mapStateToProps)(Search)